module.exports = __webpack_public_path__ + "media/icon/icon-building-gray-8b5b908b.svg";